import { IToastConfig } from 'src/common/primitives/Toast';

export function generateMemberAddSuccessToast(
  memberName: string
): IToastConfig {
  return {
    type: 'success',
    title: `Invite sent to ${memberName}`,
    description: `${memberName} will get an invitation via their email with an instruction to onboard.`,
  };
}
